module.exports = __webpack_public_path__ + "img/PUBG Girl.af5bfc8c.jpg";